<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div class="vx-row">
      <vx-card>
        <vs-table
          :max-items="descriptionItems[1]"
          pagination
          :data="historyList"
          description
          search
          @selected="handleSelected"
          :description-items="descriptionItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("leads.label.leads") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="$router.push({ name: 'Create Lead' })"
                size="small"
                >{{ $t("leads.label.new_lead") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("leads.label.user") }}</vs-th>
            <vs-th>{{ $t("leads.label.name") }}</vs-th>
            <vs-th>{{ $t("leads.label.email_id") }}</vs-th>
            <vs-th>{{ $t("leads.label.phone_number") }}</vs-th>
            <vs-th>{{ $t("leads.label.address") }}</vs-th>
            <vs-th>{{ $t("leads.label.status") }}</vs-th>
            <vs-th>{{ $t("leads.label.remark") }}</vs-th>
            <vs-th class="tHeadCenter">{{ $t("leads.label.action") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="index" :data="item" v-for="(item, index) in data">
              <vs-td :data="item.username">{{ item.username }}</vs-td>
              <vs-td :data="item.firstName">{{ item.firstName }}</vs-td>
              <vs-td :data="item.email">{{ item.email }}</vs-td>
              <vs-td :data="item.mobileNumber">{{ item.mobileNumber }}</vs-td>
              <vs-td :data="item.address">{{ item.address }}</vs-td>
              <vs-td :data="item.status">
                <vs-chip :color="statusColor(item.status)" class="leads-status"
                  >{{ item.status }}
                </vs-chip>
              </vs-td>
              <vs-td :data="item.statusRemark">{{ item.statusRemark }}</vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <img
                    v-if="
                      item.status !== 'Converted' && item.status !== 'Cancelled'
                    "
                    class="w-5 h-5 icon_row"
                    src="@/assets/images/icons/colc-img.jpg"
                    alt="Clock"
                    title="Follow Up"
                    @click.stop="followUpPopupShow(item.id)"
                  />
                  <img
                    v-if="
                      item.status !== 'Converted' && item.status !== 'Cancelled'
                    "
                    class="w-5 h-5 icon_row"
                    src="@/assets/images/icons/user-black-img.png"
                    alt="User"
                    title="Convert to Customer"
                    @click.stop="converttoclient(item.id)"
                  />
                  <feather-icon
                    v-if="
                      item.status !== 'Converted' && item.status !== 'Cancelled'
                    "
                    class="icon_row"
                    icon="TrashIcon"
                    title="delete"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    @click.stop="cancelPopupShow(item.id)"
                  />
                  <!-- <img
                    v-if="
                      item.status !== 'Converted' && item.status !== 'Cancelled'
                    "
                    class="w-5 h-5"
                    src="@/assets/images/icons/delete-orange-img.png"
                    alt="Deleted"
                    title="Deleted" 
                    @click.stop="cancelPopupShow(item.id)"
                  /> -->
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>

    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('leads.label.close_leads')"
        :active.sync="addPopup"
        class="popup-close"
      >
        <form>
          <div class="mb-5">
            <div class="vx-col sm:w-full w-full">
              <div style="width: 340px; height: 51px; border-radius: 5px">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("leads.label.status_remark")
                    }}<span class="required">*</span></small
                  >
                  <v-select
                    label="statusRemark"
                    :reduce="(obj) => obj.statusRemark"
                    :options="cancelRemark"
                    placeholder="--Select One--"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="remarkData"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                </div>
              </div>
            </div>
          </div>
          <div class="center">
            <span class="ml-3 mr-4">
              <vs-button
                type="border"
                style="width: 190px; margin-top: 20px"
                @click="addPopup = false"
                >{{ $t("leads.label.cancel") }}</vs-button
              >
            </span>
            <span class="ml-1 mr-2">
              <vs-button style="width: 190px" @click="cancelRemarkData">{{
                $t("leads.label.save")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div>

    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('leads.label.follow_up')"
        :active.sync="followPopup"
        class="popup-close"
      >
        <form>
          <div class="mb-5">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("leads.label.call_status")
                    }}<span class="required"> *</span></small
                  >
                  <v-select
                    label="callStatus"
                    :reduce="(name) => name.statusId"
                    placeholder="--Select One--"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    v-model="leads.callStatus"
                    :options="cancelPutRemark.callStatusData"
                  >
                  </v-select>
                </div>
              </div>

              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label">{{
                    $t("leads.label.next_call_date_time")
                  }}</small>
                  <flat-pickr
                    :config="configdateTimePicker"
                    class="w-full"
                    v-model="leads.preferredCallingTime"
                  />
                </div>
              </div>
            </div>

            <div style="width: 325px">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("leads.label.assigned_to")
                  }}<span class="required"> *</span></small
                >
                <v-select
                  label="assignedTo"
                  :reduce="(name) => name.assignId"
                  placeholder="--Select One--"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                  v-model="leads.assignedTo"
                  :options="cancelPutRemark.assignedToData"
                >
                </v-select>
              </div>
            </div>
            <div class="vx-col md:w-full w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("leads.label.note")
                  }}<span class="required"> *</span></small
                >
                <vs-textarea class="w-full" v-model="leads.notes" />
              </div>
            </div>
          </div>
          <div class="center">
            <span class="ml-3 mr-4">
              <vs-button
                type="border"
                style="width: 190px; margin-top: 20px; margin-bottom: 10px"
                @click="resetFollowUp"
                >{{ $t("leads.label.reset") }}</vs-button
              >
            </span>
            <span class="ml-1 mr-2">
              <vs-button style="width: 190px" @click="followUpData">{{
                $t("leads.label.save")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
import vSelect from "vue-select";
import { AtomSpinner } from "epic-spinners";
import flatPickr from "vue-flatpickr-component";
import Datepicker from "vuejs-datepicker";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

const leadsEmptyObj = {
  assignedTo: "",
  callStatus: "",
  locale: "en",
  notes: "",
  preferredCallingTime: moment().format("YYYY-MM-DD HH:mm:ss"),
};
export default {
  data() {
    return {
      loading: false,
      searchOption: 0,
      descriptionItems: [5, 10, 15],
      leads: leadsEmptyObj,
      addPopup: false,
      followPopup: false,
      updateLeadsPopup: false,
      remarkData: "",
      callStatus: "",
      assignedTo: "",
      notes: "",
      id: 0,

      warningPopup: false,
      warningText: "",
      errorMessage: "",
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "Y-m-d H:i:s",
      },
    };
  },
  components: {
    AtomSpinner,
    "v-select": vSelect,
    flatPickr,
    Datepicker,
  },
  computed: {
    ...mapState({
      cancelPutRemark: (state) => state.leads.cancelPutRemark,
      cancelRemark: (state) => state.leads.cancelRemark,
      // items: (state) => state.masters.itemList,
      historyList: (state) => state.leads.leadsHistory,
      ConvertClient: (state) => state.leads.Convert,
    }),
  },
  methods: {
    followUpData() {
      if (
        !this.leads.callStatus ||
        !this.leads.preferredCallingTime ||
        !this.leads.assignedTo ||
        !this.leads.notes
      ) {
        this.warningPopup = true;
        this.warningText = "Fill the required fields!";
      } else {
        this.warningText = "";
        this.submittedForm();
      }
    },
    statusColor(status) {
      let color = "";
      switch (status.toUpperCase()) {
        case "CONVERTED":
          color = "success";
          break;
        case "CANCELLED":
          color = "danger";
          break;
        case "PROSPECT":
          color = "warning";
          break;
        default:
          color = "blue";
      }
      return color;
    },
    reset() {
      this.leads = leadsEmptyObj;
      this.leads.callStatus = "";
      this.leads.preferredCallingTime = moment().format("YYYY-MM-DD HH:mm:ss");
      this.leads.assignedTo = "";
      this.leads.notes = "";
    },

    async getItemList() {
      this.loading = true;
      try {
        await this.$store.dispatch("leads/leadsAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      } finally {
        this.loading = false;
      }
    },

    async cancelRemarkData() {
      try {
        await this.$store.dispatch("leads/cancelProspect", {
          id: this.id,
          remark: this.remarkData,
        });
        this.addPopup = false;
        this.getItemList();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async submittedForm() {
      try {
        await this.$store.dispatch("leads/cancelPutProspect", {
          id: this.id,
          data: this.leads,
        });
        this.followPopup = false;
        this.getItemList();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    cancelPopupShow(id) {
      this.id = id;
      this.$store.dispatch("leads/leadsTemplete", id);
      this.addPopup = true;
    },
    followUpPopupShow(id) {
      this.followPopup = true;
      this.id = id;
      try {
        this.$store.dispatch("leads/leadsPutTemplete", id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    resetFollowUp() {
      (this.leads.callStatus = ""),
        (this.leads.preferredCallingTime = ""),
        (this.leads.assignedTo = ""),
        (this.leads.notes = "");
    },

    editData(id) {
      this.$router.push(`/leads_history/${id}`);
    },
    openView(item) {
      this.$router.push(`/viewitem/${item.id}`);
    },
    handleSelected(item) {
      this.$router.push({ name: "View Lead", params: { id: item.id } });
    },
    async updateLeadsLimit() {
      const leads = {
        locale: "en",
        LeadsLimitAmount: this.leads.LeadsLimitAmount,
      };
      try {
        await this.$store.dispatch("leads/setUpdateLeadsLimit", {
          id: this.leads.id,
          leads: leads,
        });

        this.updateLeadsPopup = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async converttoclient(id) {
      try {
        await this.$store.dispatch("leads/handleConvertToClient", {
          id: id,
          data: this.ConvertClient,
        });
        this.getItemList();
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },

    clearLeads() {
      this.leads.leadsLimitAmount = "";
      this.updateLeadsPopup = false;
    },
  },
  mounted() {
    this.getItemList();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}
.leads-status.vs-chip-primary {
  background: #b5dafb !important;
  border: 1px solid #3c6bec;
  color: #3c6bec !important;
}
.leads-status.vs-chip-warning {
  background: #fdf6db !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.leads-status.vs-chip-danger {
  background: #ffc2c2 !important;
  border: 1px solid #ff3838;
  color: #ff3838 !important;
}
.leads-status.vs-chip-orange {
  background: #fbd9b5 !important;
  border: 1px solid #ff8914;
  color: #ff8914 !important;
}
.leads-status.vs-chip-success {
  background: #c2f2c2 !important;
  border: 1px solid #38b838;
  color: #38b838 !important;
}
.vs-search-categeory {
  margin-top: 17px;
}
</style>
